import { createSlice } from '@reduxjs/toolkit'

export const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    theme: 'light',
    sidebarCollapsed: false,
  },
  reducers: {
    updateTheme: (state, action) => {
      state.theme = action.payload
    },
    updateSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload
    },
  },
})

export const { updateTheme, updateSidebarCollapsed } = themeSlice.actions

export default themeSlice.reducer
